import { useBi, useExperiments } from '@wix/yoshi-flow-editor';
import { riseWixPluginClickSrc35Evid201 } from '@wix/bi-logger-rise-ai-data/v2';
import { useApplicationContext } from './useApplicationContext/useApplicationContext';
import { sitePluginId, sitePluginName } from '../../consts';
import { defaultBiMultiplier, SPECS } from '../../../../consts';

export const useClickBiEvent = () => {
  const bi = useBi();
  const { userTotalStoreCreditNumber, maxRedeemableAmount } =
    useApplicationContext();
  const { experiments } = useExperiments();
  const customRedeemAmountIsEnabled = experiments.enabled(
    SPECS.RiseRedeemCustomAmount,
  );

  const reportClickBiEvent = ({
    buttonName,
    state,
    errorName,
  }: {
    buttonName: string;
    state?: string;
    errorName: string;
  }) => {
    bi.report(
      riseWixPluginClickSrc35Evid201({
        pluginId: sitePluginId,
        appName: sitePluginName,
        buttonName,
        state,
        errorName,
        balance: customRedeemAmountIsEnabled
          ? parseFloat(maxRedeemableAmount!) * defaultBiMultiplier
          : userTotalStoreCreditNumber! * defaultBiMultiplier,
      }),
    );
  };
  return { reportClickBiEvent };
};
